import React from 'react';
import ImageGrid from './ImageGrid';
import { CrawlFbResponse } from '../../../../api/crawlFb';

interface CrawlImagesProps {
  crawlData: CrawlFbResponse;
  onImageSelect?: (imageData: { imageUrl: string; title: string }) => void;
}

const CrawlImages: React.FC<CrawlImagesProps> = ({
  crawlData,
  onImageSelect,
}) => {
  const hasAnyImages =
    crawlData.postImages.length > 0 ||
    crawlData.aboutImages.length > 0 ||
    crawlData.photosOfImages.length > 0 ||
    crawlData.photosByImages.length > 0;

  if (!hasAnyImages) {
    return (
      <div className="mt-6 p-4 bg-gray-50 rounded-lg text-center">
        <svg
          className="w-8 h-8 text-gray-400 mx-auto mb-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          ></path>
        </svg>
        <p className="text-gray-600 text-sm">Không tìm thấy ảnh nào</p>
      </div>
    );
  }

  return (
    <div className="mt-6">
      <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
        <svg
          className="w-5 h-5 mr-2 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          ></path>
        </svg>
        Ảnh đã crawl
      </h4>

      <div className="space-y-6">
        <ImageGrid
          images={crawlData.postImages}
          title="📝 Ảnh từ Posts"
          maxPreview={8}
          onImageSelect={onImageSelect}
        />

        <ImageGrid
          images={crawlData.aboutImages}
          title="ℹ️ Ảnh từ About"
          maxPreview={8}
          onImageSelect={onImageSelect}
        />

        <ImageGrid
          images={crawlData.photosOfImages}
          title="📷 Photos Of (Ảnh được tag)"
          maxPreview={8}
          onImageSelect={onImageSelect}
        />

        <ImageGrid
          images={crawlData.photosByImages}
          title="🖼️ Photos By (Ảnh đã đăng)"
          maxPreview={8}
          onImageSelect={onImageSelect}
        />
      </div>
    </div>
  );
};

export default CrawlImages;
